import BaseModel from "./base-model";

export default class BaseAddress extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }
}
